import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { StateHelperService } from '../../../services/proprietary/state-helper.service';
import { InterfaceObjectState } from './interface-object.state';

@NgModule({
    imports: [NgxsModule.forFeature([InterfaceObjectState])],
    declarations: [],
    providers: [StateHelperService],
    exports: []
})
export class InterfaceObjectModule { }
